// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Paperbin_gallery__1wbGI","draggableImage":"Paperbin_draggableImage__4wqMJ"};